import React, { useState } from 'react';
import { Copy, Edit, CheckCircle } from 'lucide-react';

const ParamsCard = ({ 
  title, 
  value, 
  isCopy = true, 
  isEdit = false, 
  onEdit,
  icon = null,
  description = ''
}) => {
  const [showCopied, setShowCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    setShowCopied(true);
    setTimeout(() => setShowCopied(false), 2000);
  };

  const getValueDisplay = () => {
    if (!value) return 'N/A';
    if (typeof value === 'boolean') return value.toString();
    return value;
  };

  return (
    <div className="group bg-gray-50 rounded-lg p-5 border border-gray-200 hover:border-indigo-200 transition-all duration-200 hover:shadow-md">
      <div className="flex items-center mb-2">
        {icon}
        <h3 className="text-gray-600 text-sm font-medium ml-2">{title}</h3>
        {isEdit && (
          <button
            onClick={onEdit}
            className="ml-auto p-1.5 text-gray-400 hover:text-indigo-600 hover:bg-indigo-50 rounded-md transition-colors"
            title="Edit value"
          >
            <Edit className="h-4 w-4" />
          </button>
        )}
      </div>

      <div className="flex items-center mt-1">
        {isCopy && value && (
          <button 
            onClick={handleCopy}
            className="mr-2 p-1.5 text-gray-400 hover:text-indigo-600 hover:bg-indigo-50 rounded-md transition-colors"
            title="Copy to clipboard"
          >
            {showCopied ? (
              <CheckCircle className="h-4 w-4 text-green-500" />
            ) : (
              <Copy className="h-4 w-4" />
            )}
          </button>
        )}
        <p className="text-gray-900 font-semibold text-lg break-all flex-grow">
          {getValueDisplay()}
        </p>
      </div>
      
    </div>
  );
};

export default ParamsCard;